<template>
  <div class="activity_log">
    <h4 class="activity_log__title">
      <span
          v-if="is_hidden"
          class="activity_log__go_back"
          @click="$emit('hide')"
      >
        <img
            :src="require('@/assets/static/images/arrow_back.svg')"
            alt="arrow back"
        />
      </span>
      {{ $t('activity_log.title') }}
    </h4>
    <div v-if="is_hidden" class="activity_log__switch">
      <span v-html="$t('activity_log.show_sidebar')"></span>
      <el-switch
          v-model="activityLogSwitcher"
          @change="changeShowSmallActivityLog"
          active-color="#FF8686"
          :width="27"
      ></el-switch>
    </div>
    <ul class="activity_log__list vertical_scrollbar" v-if="getHistory.length > 0">
      <li
          v-for="history in getHistory.slice(0, count)"
          :key="history._id"
          :id="history._id"
          :data-author="history.author"
          :data-color="history.color"
          class="activity_log__item"
          :class="setClass(history)"
          :style="`background-color: ` + history.color == 'green'
            ? '#F7FFF6'
            : history.color == 'red'
            ? '#FAD0D0'
            : history.color == 'blue'
            ? '#F0FBFF'
            : '#FAFAFA'"
          @click="toActiveEssence(history)"
      >
        <span class="activity_log__item__avatar" :style="'background-color: ' + getUser(history.author).color" v-html="$w_user_image(getUser(history.author))"></span>
        <div>
          <h5 class="activity_log__item__title" v-html="translateOutsideBold(textHyphenated(history.message))"></h5>
          <p v-if="history.chat_message"><span>{{ history.chat_message }}</span></p>

          <span class="activity_log__item__date">{{ last_time(+history.date) }}
              <i v-if="createDate(+history.date) != 'Yesterday'">{{
                  createDate(+history.date) + ' ' +$t('activity_log_msg.at')+ ' ' + $w_time_parse(new Date(+history.date), getUserData.date_format.time)
                }}</i>
              <i v-else>{{
                  createDate2(+history.date) + ' ' +$t('activity_log_msg.at')+ ' ' + $w_time_parse(new Date(+history.date), getUserData.date_format.time)
                }}</i>

            </span>
        </div>
      </li>
    </ul>
    <p v-else class="no_logs">{{ $t('activity_log.not_log') }}</p>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import { EventEmitter } from '../../main'
import { hyphenated } from 'hyphenated'
import NotFound from '@/components/app/NotFound'
import moment from "moment/moment";

export default {
  name: "ActivityLog",
  props: {
    is_hidden: [Boolean],
    count: [Number]
  },
  data() {
    return {
      activityLogSwitcher: false,
      cur_date: Date.now(),
      now: Date.now(),
      timer: null,
      alignTimeout: null
    };
  },
  components: {
    NotFound
  },
  computed: {
    ...mapGetters([
      "getHistory",
      "getShowSmalActivityLog",
      "getUserData",
      "getComments",
      "getKnownUsers",
      "getTasks",
      "getCompletedTasks",
      "getProjects",
      "getChats"
    ]),
  },
  // mounted() {
    
  //   this.activityLogSwitcher = this.getUserData.show_sidebar

  //   this.timer = setInterval(() => {
  //     this.cur_date = Date.now();
  //   }, 60 * 1000);

  // },
  mounted() {

    this.activityLogSwitcher = this.getUserData.show_sidebar

    const msToNextMinute = 60000 - (Date.now() % 60000);
    // дождёмся границы минуты
    this.alignTimeout = setTimeout(() => {
      this.now = Date.now();
      this.timer = setInterval(() => { this.now = Date.now(); }, 60000);
    }, msToNextMinute);
  },
  beforeDestroy() {
    clearTimeout(this.alignTimeout);
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations([
      "setJumpToMessage",
      "setShowSmalActivityLog",
      "setMessage",
    ]),
    getSlug(text) {
      return text.split(" ").join("_")
    },
    normalizeLatin(text) {
      // Заменяем кириллические буквы на похожие латинские
      const map = {
        'А':'A', 'В':'B', 'Е':'E', 'К':'K', 'М':'M', 'Н':'H', 'О':'O', 'Р':'P',
        'С':'C', 'Т':'T', 'У':'Y', 'Х':'X',
        'а':'a', 'е':'e', 'о':'o', 'р':'p', 'с':'c', 'у':'y', 'х':'x'
      };
      return text.replace(/[А-Яа-я]/g, ch => map[ch] || ch);
    },
    translateOutsideBold(html) {
      const container = document.createElement('div');
      container.innerHTML = html;

      const walk = (node) => {
        node.childNodes.forEach(child => {
          if (child.nodeType === Node.TEXT_NODE) {
            const text = child.textContent.trim();
            if (text) {
              // Переводим только если есть такой ключ
              child.textContent = this.$i18n.te(`activity_log_msg.${this.getSlug(text.replace(/[\u00ad]/g, ''))}`)
                ? " " + this.$t(`activity_log_msg.${this.getSlug(text.replace(/[\u00ad]/g, ''))}`) + " "
                : " " + text + " ";
            }
          } else if (
            child.nodeType === Node.ELEMENT_NODE &&
            child.tagName !== 'B'
          ) {
            walk(child); // рекурсивно обходим всё, кроме <b>
          }
        });
      };

      walk(container);
      return container.innerHTML;
    },
    last_time(e) {
      // ВАЖНО: читаем this.now, чтобы Vue "знал", что метод зависит от reactive now
      const tick = this.now; // <-- эта строка создаёт реактивную зависимость

      // безопасный расчёт, чтобы не показывало "через несколько секунд"
      let eventTime = new Date(e).getTime();
      const actualNow = Date.now();
      if (eventTime > actualNow) eventTime = actualNow;
      if (actualNow - eventTime < 1000) eventTime = actualNow - 1000;

      return moment(eventTime).locale(this.$i18n.locale).from(moment(actualNow));
      let
          result = '',
          date = this.cur_date,
          now = date.getTime(),
          time = parseInt((now - e)/1000),
          minutes = Math.ceil(time/60),
          hours = parseInt(minutes/60),
          prefix = ' ' + this.$t('activity_log.last_time.ago'),
          difference = date.getHours() * 60 * 60 + date.getMinutes() * 60 + date.getSeconds();
      // console.log(difference)

      let days = Math.round((time)/3600/24 );
      // console.log('day ' + days)

      if (days >= 92)
      {
        result = this.$t('activity_log.last_time.few_months')
      }
      else if (days >= 62)
      {
        result = this.$t('activity_log.last_time.two_months')
      }
      else if (days >= 31)
      {
        result = this.$t('activity_log.last_time.month')
      }
      else if (days >= 21) (
          result = this.$t('activity_log.last_time.three_weeks')
      )
      else if (days >= 14)
      {
        result = this.$t('activity_log.last_time.two_weeks')
      }
      else if (days >= 7)
      {
        result = this.$t('activity_log.last_time.week')
      }
      else if (days >= 2)
      {
        result = days + ' ' + this.$t('activity_log.last_time.days')
      }
      else if (hours >= 24 )
      {
        result = this.$t('activity_log.last_time.one_day')
      }
      else if (hours >= 2)
      {
        result = hours + ' '+this.$t('activity_log.last_time.hours')
      }
      else if ( hours == 1)
      {
        result = this.$t('activity_log.last_time.one_hour')
      }
      else if (minutes > 2)
      {
        result = minutes + ' ' + this.$t('activity_log.last_time.minutes')
      }
      else if (time > 60)
      {
        result = this.$t('activity_log.last_time.one_minute')
      }
      else
      {
        prefix = '';
        result = this.$t('activity_log.last_time.just_now')
      }

      return result + prefix;
    },
    projectScroll() {
      setTimeout(() => {
        if (document.querySelector('.projects')) {
          if (document.querySelector('.lists')) {
            let height_project = document.querySelector('.projects').clientHeight
            let height_lists = document.querySelector('.lists').clientHeight

            if (height_project > height_lists) {
              document.querySelector('.lists').classList.add('no-scroll')
            } else {
              document.querySelector('.lists').classList.remove('no-scroll')
            }
          }
          if (document.querySelector('.chats')) {
            let height_project = document.querySelector('.projects').clientHeight
            let height_chats = document.querySelector('.chats').clientHeight

            if (height_project > height_chats) {
              document.querySelector('.chats').classList.add('no-scroll')
            } else {
              document.querySelector('.chats').classList.remove('no-scroll')
            }
          }
        }
      }, 1)
    },
    getComment(type) {
      if (this.getComments[type.task_id]) {
        let data = this.getComments[type.task_id].filter((e) => e._id == type._id)
        if (data) {
          if (data[0]) {
            return data[0].message
          } else {
            return ''
          }
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    createDate(e) {
      const fullDate = this.$w_date_parse(e, "history")

      let date = fullDate.split('/')

      if (this.getUserData.date_format) {
        if (this.getUserData.date_format.date) {
          if (this.getUserData.date_format.date == 'DD/MM/YYYY') {
            return fullDate == 'Today' ? this.$t('task.assign.today') : fullDate
          }
          if (this.getUserData.date_format.date == 'MM/DD/YYYY') {
            if (date[2]) {
              return date[1] + '/' + date[0] + '/' + date[2]
            }
            if (date[0]) {
              return date[0]
            }
          }
        }
      }

    },
    createDate2(e) {
      let date = new Date(e);

      let day = date.getDate() > 9 ? date.getDate(): '0' + date.getDate()
      if (this.getUserData.date_format.date) {
        if (this.getUserData.date_format.date == 'DD/MM/YYYY') {
          return day + '/' + (date.getMonth() + 1) + '/' + (date.getFullYear() % 100)
        }
        if (this.getUserData.date_format.date == 'MM/DD/YYYY') {
          return (date.getMonth() + 1) + '/' + day + '/' + (date.getFullYear() % 100)
        }
      }

    },
    handleOpenParentTask({type}) {
      const project_id = type.project_id
      // Some logs do not have task_id property and the ids are given as just _id
      let task_id = type._id

      if (type.task_id) {
        task_id = type.task_id
      }

      // console.log(this.getTasks[project_id], 'get tasks')
      // console.log(this.getCompletedTasks[project_id], 'get completed tasks')

      let task = this.getTasks[project_id].find(task => task._id == task_id)

      if (!task) {
        task = this.getCompletedTasks[project_id].find(task => task._id == task_id)
      }

      if (task.parent) {
        EventEmitter.$emit('openSubtask', task._id)
      }
    },
    toActiveEssence(history) {
      if (history.type.type != 'delete') {

        console.log(history)

        const hasData = (type, id) => {

          if (type == 'task') {
            if (history.type.project_id) {
              let getTasks = this.getTasks[history.type.project_id] ? this.getTasks[history.type.project_id].filter(e => e._id == id) : []
              let getCompletedTasks = this.getCompletedTasks[history.type.project_id] ? this.getCompletedTasks[history.type.project_id].filter(e => e._id == id) : []
              if (getTasks.length > 0 || getCompletedTasks.length > 0) {
                return true
              } else {
                this.setMessage({
                  key_message: "warning",
                  message: this.$t('activity_log.longer_exists'),
                })
                return false
              }
            }
          }

          if (type == 'list') {
            let getProjects = this.getProjects.filter(e => e._id == id)
            if (getProjects.length > 0) {
              return true
            } else {
              this.setMessage({
                key_message: "warning",
                message: this.$t('activity_log.longer_exists'),
              })
              return false
            }
          }

          if (type == 'msg') {
            let getComments = this.getComments[history.type.task_id] ? this.getComments[history.type.task_id].filter(e => e._id == id) : []
            if (getComments.length > 0) {
              return true
            } else {
              this.setMessage({
                key_message: "warning",
                message: this.$t('activity_log.longer_exists'),
              })
              return false
            }
          }

        }

        if (history.type.type == "chat" || history.type.type == "msg") {
          if (history.remove_message) {
            this.setMessage({
              key_message: "warning",
              message: this.$t('activity_log.longer_exists'),
            })
          } else {
            if (history.type.task_id) {
              if (hasData('task', history.type.task_id)) {
                if (this.$route.params.task_id != history.type.task_id) {
                  this.$router.push(`/project/${history.type.project_id}/task/${history.type.task_id}`)
                }
                setTimeout(() => {
                  this.setJumpToMessage(history.type._id)
                }, 500)
                this.handleOpenParentTask(history)
              }
            } else if (this.getChats.some(e => e._id == history.type._id)) {
              this.$router.push(history.src)
            } else {
              this.setMessage({
                key_message: "warning",
                message: this.$t('activity_log.longer_exists'),
              })
            }
          }
        }

        if (history.type.type == "tasks") {
          if (hasData('task', history.type._id)) {
            if (this.$route.params.task_id != history.type._id) {
              this.$router.push(history.src)
            }
            this.handleOpenParentTask(history)
          }
        }

        if (history.type.type == "project") {
          if (hasData('list', history.type._id)) {
            if (this.$route.params.project_id != history.type._id) {
              this.$router.push(history.src)
            }
          }
        }

      }
    },
    setClass(history) {
      let newClass = "";
      newClass += history.type && history.type.type != "delete" ? "has_link" : "";
      newClass += history.new ? " leftToRight" : "";
      return newClass;
    },
    changeShowSmallActivityLog() {
      // console.log(this.activityLogSwitcher)
      // EventEmitter.$emit('OUT_ShowSidebar', data)
      this.$socket.emit('IN_ShowSidebar', this.activityLogSwitcher)
      this.setShowSmalActivityLog(this.activityLogSwitcher)
      this.projectScroll()
      // localStorage.setItem("showSmallActivityLog", this.activityLogSwitcher);
    },
    getUser(user_id) {

      let user = ''

      if (user_id == this.getUserData._id) {
        user = this.getUserData
      }

      this.getKnownUsers.forEach(e => {
        if (e._id == user_id) {
          user = e
        }
      })

      return user

    },
    textHyphenated(text) {
      return hyphenated(text)
    }
  },
};
</script>
